// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
  let variant = evt.detail.variant;
  let $form = document.querySelector('.quick-product--wrap.is-visible .product-form__controls-group')  || document.querySelector('.product-form__controls-group');
  if (!$form) return;
  $form.classList.toggle('product-form--soldout', !variant.available);
});



const UTILS = (() => {
  const AddItemsToCart = (itemsToAdd) => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: itemsToAdd })
    });
  };

  const GetCartJson = () => {
    return fetch('/cart.js').then((res) => res.json());
  }

  const RefreshCart = async (item) => {
    let cart = await GetCartJson();
    let isCartPage = document.querySelectorAll('.template-cart').length !== 0;

    if (isCartPage) {
      window.location.reload();
      return;
    }

    let r$1 = window.r$1;
    r$1("quick-cart:updated");
    r$1("cart:updated", { cart });

    // Need a delay to allow quick-cart to refresh
    setTimeout(function () {
      r$1("quick-cart:open");

      let $quickModal = document.querySelector('.quick-product--wrap.modal.active');
      if ($quickModal) {
        $quickModal.querySelector('[data-modal-close]').dispatchEvent(new Event('click', {bubbles: true}));
      }
    }, 300);

  }

  const GetLocation = async () => {
    const SESSION_KEY = 'loc_country';
    let location = sessionStorage.getItem(SESSION_KEY);
    if (!location) {
      location = await fetch('/browsing_context_suggestions.json').then(res => res.json());
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(location));
    }
    else {
      location = JSON.parse(location);
    }
    return location;
  }

  const FormatMoney = (value) => {
    // Reproduces accounting.formatMoney(v/100, { symbol: "$", format: "%s %v" }):
    // symbol, single space, thousands-grouped, 2-decimal. (accounting.js removed.)
    let amount = value / 100;
    let sign = amount < 0 ? '-' : '';
    let parts = Math.abs(amount).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$ ' + sign + parts.join('.');
  }

  return {
    AddItemsToCart,
    GetCartJson,
    RefreshCart,
    GetLocation,
    FormatMoney
  };
})();

// Try on toggle
document.addEventListener('init-filter-tryon', (e) => {
  e.currentTarget.addEventListener('click', (evt) => {
    let isMobile = window.matchMedia('(max-width: 479px)').matches;
    let isToggleBtn = (evt.target.classList.contains('tryon-button-img') || 
      evt.target.classList.contains('tryon-button-button') || 
      evt.target.closest('.close-btn') !== null);

    if (isToggleBtn) {
      if (isMobile) {
        let $container = evt.target.closest('[data-tryon_url]');
        let tryon_url = $container.dataset.tryon_url;
        window.open(tryon_url, '_blank');
        return;
      }
      let $tryon = evt.target.closest('.tryon-filter');
      $tryon.classList.toggle('visible');
    }
  });
});

// Gorgias chat links
document.querySelectorAll('[href="#gorgias-chat-open"]').forEach(($link) => {
  $link.addEventListener('click', (e) => {
    e.preventDefault();
    if (window.GorgiasChat) {
      GorgiasChat.open();
    }
  });
});

// Freeship callout based on country
document.addEventListener('alpine:init', () => {
  Alpine.data('freeshipping_callout', () => ({
      settings: null,
      location: null,
      init() {
        let am = this;
        (async() => {
          let location = await UTILS.GetLocation();
          am.location = location;
        })();
      },
      setSettings(settings) {
        this.settings = Object.assign(settings, FS_SETTINGS);
      },
      getThreshold() {
        let am = this;
        let country = am.location ? am.location.detected_values.country.handle : '';
        let isGroup1 = am.settings.group_1_country.replaceAll(', ', ',').split(',').indexOf(country) !== -1;
        let threshold = isGroup1 ? am.settings.group_1_threshold : am.settings.rest_threshold;
        return threshold;
      },
      getMessage() {
        let am = this;
        let message = am.settings.message;
        return message
          .replaceAll('[threshold]', `<span class="money">$${ am.settings.group_1_threshold }</span>`)
          .replaceAll('[threshold2]', `<span class="money">$${ am.settings.rest_threshold }</span>`);
      }
  }))

  // glass prescription calculator
  Alpine.data('ConvertPrescription', () => ({
    $section: null,
    initialized: false,
    init() {
      let am = this;
      document.addEventListener('init-ConvertPrescription', (e) => {
        if (am.initialized) return;

        am.$section = e.target;
        am.initialized = true;
      });
    },
    Convert() {
      let am = this;
      if (!am.$section) return;
      let $section = am.$section;
      // Get input values
      const ODsphere = parseFloat($section.querySelector('#ODsphere').value);
      const ODcylinder = parseFloat($section.querySelector('#ODcylinder').value);
      const ODaxis = parseFloat($section.querySelector('#ODaxis').value);
      const OSsphere = parseFloat($section.querySelector('#OSsphere').value);
      const OScylinder = parseFloat($section.querySelector('#OScylinder').value);
      const OSaxis = parseFloat($section.querySelector('#OSaxis').value);

      // Conversion function
      const convertSphere = (sphere) => {
        if (sphere === 0) {
          return 0;
        } else if (Math.abs(sphere) <= 4) {
          return sphere;
        } else {
          const vertexDistance = 0.012;
          const contactLensSphere = sphere / (1 - (vertexDistance * sphere));
          if (Math.abs(contactLensSphere) < 6) {
            return Math.round(contactLensSphere * 4) / 4;
          } else {
            return Math.round(contactLensSphere * 2) / 2;
          }
        }
      };

      // Calculate contact lens sphere values
      const ODcontactLensSphere = convertSphere(ODsphere);
      const OScontactLensSphere = convertSphere(OSsphere);

      // Set the contact lens sphere values
      $section.querySelector('#ODcontactLensSphere').value = isNaN(ODcontactLensSphere) ? '' : ODcontactLensSphere.toFixed(2);
      $section.querySelector('#OScontactLensSphere').value = isNaN(OScontactLensSphere) ? '' : OScontactLensSphere.toFixed(2);

      // Calculate and set contact lens cylinder and axis values if provided
      if (!isNaN(ODcylinder) && !isNaN(ODaxis)) {
        $section.querySelector('#ODcontactLensCylinder').value = (Math.round(ODcylinder * 4) / 4).toFixed(2);
        $section.querySelector('#ODcontactLensAxis').value = (Math.round(ODaxis / 10) * 10) % 180 || 180;
      } else {
        $section.querySelector('#ODcontactLensCylinder').value = '';
        $section.querySelector('#ODcontactLensAxis').value = '';
      }

      if (!isNaN(OScylinder) && !isNaN(OSaxis)) {
        $section.querySelector('#OScontactLensCylinder').value = (Math.round(OScylinder * 4) / 4).toFixed(2);
        $section.querySelector('#OScontactLensAxis').value = (Math.round(OSaxis / 10) * 10) % 180 || 180;
      } else {
        $section.querySelector('#OScontactLensCylinder').value = '';
        $section.querySelector('#OScontactLensAxis').value = '';
      }
    }
  }));

  // Readmore toggle text
  Alpine.data('ReadMoreToggle', (p_options) => ({
    $section: null,
    p_options: p_options,
    isMobile: matchMedia('(max-width:720px)').matches,
    maxChars: p_options.maxChars,
    selector: p_options.selector,
    init() {
      let am = this;
      document.addEventListener('init-ReadMoreToggle', (e) => {
        if (am.$section) return;

        am.$section = e.target;
        if (am.p_options.desktop && !am.isMobile) {
          am.InitReadMoreToggle();
        }
        if (am.p_options.mobile && am.isMobile) {
          am.InitReadMoreToggle();
        }
      });
    },
    InitReadMoreToggle() {
      let am = this;
      let $content = am.$section.querySelector(am.selector);
      let text = $content.textContent;
      let html = $content.innerHTML;
      if (text.length > am.maxChars) {
        let short_text = text.slice(0, 195);

        $content.textContent = '';
        $content.insertAdjacentHTML('afterbegin', `
          <span class="short-text">${ short_text }... <a class="toggle-link" href="#">More</a></span>
          <span class="full-text">${ html }<a class="toggle-link" href="#">Less</a></span>
        `);

        $content.addEventListener('click', (e) => {
          e.preventDefault();
          if (e.target.classList.contains('toggle-link')) {
            e.stopPropagation();
            $content.classList.toggle('active');
          }
        });
      }
    }
  }));

  // CollapsibleRows
  Alpine.data('CollapsibleRows', () => ({
    $section: null,
    init() {
      let am = this;
      document.addEventListener('init-CollapsibleRows', (e) => {
        if (am.$section) return;

        am.$section = e.target;
        am.ReformatItemsList();
      });
    },
    ReformatItemsList() {
      let am = this;
      let $items = [...am.$section.querySelectorAll('.collapsible-row-list-item')];
      let count = $items.length;
      let midpoint = count / 2;
      $items = [$items.slice(0, midpoint), $items.slice(-midpoint)];

      [1,2].forEach((group_index) => {
        let $group = am.$section.querySelector(`.group--${ group_index }`);
        $items[(group_index - 1)].forEach(($item) => {
          $group.insertAdjacentElement('beforeend', $item);
        });
      });
    }
  }));

  // Pair qty
  Alpine.data('QtyPair', () => ({
    qty: 1,
    pair_id: Date.now(),
    init() {
      this.$watch('qty', () => {
        this.pair_id = Date.now()
      });
    }
  }));

  Alpine.data('ProductPairSelect', () => ({
    product: null,
    cache: {},
    power_R: '0.00 (non prescription)',
    power_L: '0.00 (non prescription)',
    init() {
      this.InitCache();
      this.InitSelf();
      this.InitEvents();
      this.InitBuyItNowIntercept();
      this.InitPairPrice();
    },
    InitCache() {
      let am = this;
      am.cache.$product_main = am.$el.closest('.quick-product--wrap') || am.$el.closest('.product__details');
      am.cache.$btn_atc = am.cache.$product_main.querySelector('[name=add]');
      am.cache.$qty = am.cache.$product_main.querySelector('[data-quantity-input]');
    },
    InitSelf() {
      let am = this;
      am.product = JSON.parse(am.$el.dataset.product);
    },
    InitEvents() {
      let am = this;
      if (!am.cache.$btn_atc) return;

      let $product_main = am.cache.$product_main;

      am.cache.$btn_atc.classList.remove('btn--secondary');
      am.cache.$btn_atc.classList.add('btn--primary');

      // Delegate on the product container (capture) so the intercept survives
      // buy-button block re-renders that replace the cached button node
      $product_main.addEventListener('click', async (e) => {
        let $btn_atc = e.target.closest('[name=add]');
        if (!$btn_atc) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        let $qty = $product_main.querySelector('[data-quantity-input]') || am.cache.$qty;

        let $subscribe = $product_main.querySelector('[data-type="subscription"]');
        let isSubscription = ($subscribe && $subscribe.checked) || false;

        let $options = [...$product_main.querySelectorAll('.variant-picker-pairs select')];
        let itemsToAdd = am.buildPairItems($options, $qty, isSubscription);
        
        let add_req = await UTILS.AddItemsToCart(itemsToAdd);
        if (add_req.ok) {
          UTILS.RefreshCart();
        }
      }, true);
    },
    buildPairItems($options, $qty, isSubscription) {
      let am = this;
      let $product_main = am.cache.$product_main;
      let pair_id = Date.now();
      return $options.map(($select, pair_eye_idx) => {
        let variant_id = $select.value;
        let item = {
          quantity: $qty.value,
          id: variant_id,
          properties: {
            'Power R': $options[0].querySelector('option:checked').dataset.title,
            'Power L': $options[1].querySelector('option:checked').dataset.title,
            '_pair': 'true',
            '_pair_id': pair_id,
            '_eye': pair_eye_idx === 0 ? 'R' : 'L'
          }
        };

        if (isSubscription) {
          let variant = am.product.variants.find(v => variant_id == v.id);
          let selected_frequency_index = $product_main.querySelector('[name=subs_interval]').selectedIndex;
          let selling_plan = variant.selling_plan_allocations[selected_frequency_index];
          item.selling_plan = selling_plan.selling_plan_id;
        }
        return item;
      });
    },
    InitBuyItNowIntercept() {
      let am = this;
      if (!am.cache.$btn_atc) return;

      let $product_main = am.cache.$product_main;

      // Delegate on the product container (capture) so the intercept survives
      // buy-button block re-renders that replace the payment button wrapper
      $product_main.addEventListener('click', async (e) => {
        let $paymentWrapper = e.target.closest('[data-shopify="payment-button"]');
        if (!$paymentWrapper) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        let $qty = $product_main.querySelector('[data-quantity-input]') || am.cache.$qty;

        let $subscribe = $product_main.querySelector('[data-type="subscription"]');
        let isSubscription = ($subscribe && $subscribe.checked) || false;

        let $options = [...$product_main.querySelectorAll('.variant-picker-pairs select')];
        if ($options.length !== 2) return;

        let itemsToAdd = am.buildPairItems($options, $qty, isSubscription);

        let add_req = await UTILS.AddItemsToCart(itemsToAdd);
        if (add_req.ok) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'checkout_method': 'buy_it_now' } })
          });
          window.location.href = '/checkout';
        }
        else {
          console.error('Buy It Now pair add failed:', add_req);
        }
      }, true);
    },
    /* Jul 29 2026: the PDP price is server-rendered from the default variant
       (current_variant.price x 2), so surcharge powers (+$5 / +$30 custom order)
       left the displayed "/pair" price stale while the cart charged correctly.
       Recompute it from the two selected variants. Money text comes from the
       shop's own money format with tags stripped (never inject the raw HTML
       format), and the span keeps span.money + a refreshed data-ec-usd so the
       display-currency module reconverts it. Compare-at / "Save" are detached
       while a surcharge is selected and re-attached when both eyes are back on
       base: moving the same nodes (rather than rewriting innerHTML) keeps their
       currency-conversion state, and keeps the "Save" <svg> out of the STOQ
       MutationObserver's addedNodes above, whose node.className.toLowerCase()
       throws on SVG elements (SVGAnimatedString). */
    InitPairPrice() {
      let am = this;
      let $product_main = am.cache.$product_main;
      if (!$product_main || !am.product || !am.product.variants) return;

      let $selects = [...am.$el.querySelectorAll('select')];
      if ($selects.length !== 2) return;

      let $price_wrap = $product_main.querySelector('.product__block--product-header .product__price')
        || $product_main.querySelector('.product__price');
      if (!$price_wrap) return;
      if (!$price_wrap.querySelector('[data-price] .money')) return;

      let $compare = $price_wrap.querySelector('[data-compare-price]');
      let $discount = $price_wrap.querySelector('[data-discount-display]');
      let original = {
        compare: $compare ? $compare.innerHTML : null,
        discount: $discount ? $discount.innerHTML : null
      };

      let money_format = (window.theme && window.theme.moneyFormat) || '';
      let MoneyText = (cents) => {
        let amount = UTILS.FormatMoney(cents).replace(/^\$\s*/, '');
        if (money_format.indexOf('{{amount}}') === -1
          && money_format.indexOf('{{ amount }}') === -1) return UTILS.FormatMoney(cents);
        return money_format
          .replace(/\{\{\s*amount\s*\}\}/, amount)
          .replace(/<[^>]*>/g, '');
      };

      let PriceOf = (variant_id) => {
        let variant = am.product.variants.find(v => String(v.id) === String(variant_id));
        return variant ? variant.price : null;
      };

      let base_sum = PriceOf($selects[0].value) + PriceOf($selects[1].value);

      let Update = () => {
        let price_R = PriceOf($selects[0].value);
        let price_L = PriceOf($selects[1].value);
        if (price_R === null || price_L === null) return;
        let sum = price_R + price_L;

        // re-query: the theme's own updatePrices() can replace [data-price] markup
        let $money = $price_wrap.querySelector('[data-price] .money');
        if (!$money) return;

        $money.setAttribute('data-ec-usd', (sum / 100).toFixed(2));
        $money.removeAttribute('data-ec-cur');
        $money.textContent = MoneyText(sum);

        let is_base = sum === base_sum;
        if ($compare && original.compare !== null) $compare.innerHTML = is_base ? original.compare : '';
        if ($discount && original.discount !== null) $discount.innerHTML = is_base ? original.discount : '';
      };

      $selects.forEach(($select) => $select.addEventListener('change', Update));
      Update();
    }
  }));

  // Cart qty pairs
  Alpine.data('CartQtyPair', (qty, lineitem_key, isPairSeparate) => ({
    qty: qty,
    lineitem_key: lineitem_key,
    isPairSeparate: isPairSeparate,
    init() {
      let am = this;
      am.$watch('qty', am.UpdateQuantity.bind(am));
    },
    UpdateQuantity() {
      let am = this;
      (async() => {
        let cart = await fetch('/cart.js').then(res => res.json());
        let line_item = cart.items.find(item => item.key == am.lineitem_key);
        let qty = am.qty;
        if (!line_item || !line_item.properties) return;
  
        let updates = {};
        if (!am.isPairSeparate) {
          qty *= 2;
        }
  
        if (am.isPairSeparate) {
          let pair_id = line_item.properties['_pair_id'];
          let line_items_pair = cart.items.filter(item => item.properties && item.properties._pair_id == pair_id);
    
          line_items_pair.forEach((item) => {
            updates[item.key] = qty;
          });  
        }
        else {
          updates[line_item.key] = qty;
        }
  
        console.log(updates)
  
        let update_req = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates: updates })
        });
  
        if (update_req.ok) {
          UTILS.RefreshCart();
        }
        else {
          console.error(update_req);
        }
      })();  
    }
  }));

  // fix - on image change, play/pause video
  document.addEventListener('update-main-image', (e) => {
    let $mediaContainer = e.target.closest('.product__media-container');
    if (!$mediaContainer) return;

    let $video = $mediaContainer.querySelector(`[data-video-id="${ e.detail.id }"] video`);
    if (!$video) {
      // pause all videos in container
      $mediaContainer.querySelectorAll('video').forEach(($video) => {
        $video.pause();
      });
      return;
    };
    
    $video.controls = true;
    $video.play();
  });

  // fix - mobile carousel, on image change, play/pause video
  document.addEventListener('init-media-carousel', (e) => {
    let $mediaContainer = e.target;

    setTimeout(() => {
      let swiper = $mediaContainer.swiper;
      if (!swiper) return;
  
      swiper.on('slideChangeTransitionEnd', () => {
        let $video = $mediaContainer.querySelector('.swiper-slide-active video');
        if (!$video) {
          $mediaContainer.querySelectorAll('video').forEach(($video) => {
            $video.pause();
          });
    
          return;
        }
  
        $video.controls = true;
        $video.play();  
      });  
    }, 2000);
  });

  // output helpers 
  Alpine.data('DATA', (item) => ({
    init() {
      document.querySelectorAll(`[x-data="DATA('${ item }')"]`).forEach(($item) => {
        let replace_text = '';
        switch(item) {
          case 'fs-threshold-1':
            replace_text = FS_SETTINGS.group_1_threshold;
            break;
          case 'fs-threshold-2':
            replace_text = FS_SETTINGS.rest_threshold;
            break;
          case 'country':
            let loc_country = JSON.parse(sessionStorage.getItem('loc_country'));
            replace_text = `${ loc_country.detected_values.country.name }`;
            break;
        }

        $item.textContent = `$${ replace_text }`;
      });
    }
  }));

  Alpine.data('FreeShipBar', () => ({
    config: {
      threshold_1: 0,
      message_1_inc: '',
      message_1_comp: '',
      fg_title: '',
      threshold_2: 0,
      message_2_inc: '',
      message_2_comp: ''
    },
    flags: {
      progress: 0
    },
    cart: null,
    mounted() {
      let am = this
      am.config.threshold_1 = parseFloat(am.$el.dataset.threshold_1) || 0
      am.config.message_1_inc = am.$el.dataset.message_1_inc
      am.config.message_1_comp = am.$el.dataset.message_1_comp
      am.config.fg_title = am.$el.dataset.fg_title

      am.config.threshold_2 = parseFloat(am.$el.dataset.threshold_2) || 0
      am.config.message_2_inc = am.$el.dataset.message_2_inc
      am.config.message_2_comp = am.$el.dataset.message_2_comp

      if (!am.config.threshold_1 && !am.config.threshold_2) {
        am.$el.classList.add('visually-hidden')
      }

      am.config.message_3 = am.$el.dataset.message_3

      am.CheckProgress()

      document.addEventListener("cart:updated", (e) => {
        am.CheckProgress()
      })
    },
    CheckProgress() {
      let am = this;
      (async() => {
        am.cart = await UTILS.GetCartJson()
        let threshold = am.config.threshold_1
        if (am.config.threshold_2 > am.config.threshold_1) {
          threshold = am.config.threshold_2
        }
        am.flags.progress = (am.cart.total_price / threshold) * 100
      })()
    },
    GetProgressStyle() {
      let am = this
      let obj = {}
      obj['--progress-width'] = `${ am.flags.progress }%`
      return obj
    },
    GetProgressMessage() {
      let am = this
      if (!am.cart) return ''

      let msg = []
      if (am.config.threshold_1) {
        let msg_1 
        let progress_1 = (am.cart.total_price / am.config.threshold_1) * 100
        if (progress_1 < 100) {
          let fg_remaining = am.config.threshold_1 - am.cart.total_price
          msg_1 = am.config.message_1_inc.replace('$X', `<strong><span class=money>${ UTILS.FormatMoney(fg_remaining) }</span></strong>`)
          msg_1 = msg_1.replace('$TITLE', `${ am.config.fg_title }`)
        }
        else {
          msg_1 = am.config.message_1_comp
          msg_1 = msg_1.replace('$TITLE', `${ am.config.fg_title }`)
        }
        msg.push(msg_1)
      }
      if (am.config.threshold_2) {
        let msg_2
        let progress_2 = (am.cart.total_price / am.config.threshold_2) * 100
        if (progress_2 < 100) {
          let fs_remaining = am.config.threshold_2 - am.cart.total_price
          msg_2 = am.config.message_2_inc.replace('$X', `<strong><span class=money>${ UTILS.FormatMoney(fs_remaining) }</span></strong>`)
        }
        else {
          msg_2 = am.config.message_2_comp
        }
        msg.push(msg_2)
      }

      if (am.config.threshold_1 > am.config.threshold_2) {
        msg = msg.reverse()
      }

      return msg.join('<br />')
    }
  }))
});
// Cart automation: auto free gifts.
// One pipeline, one debounced entry point, shared cart fetch.
// - Empty cart: a single /cart.js request, nothing else.
// - Gifts: up to 3 offers from Theme settings > Free Gifts (auto-add), config
//   read from the gift-eligibility section. GWP-mode gifts are $0 products,
//   added when qualifying and removed when not. Discount-mode gifts are
//   regular products zeroed by a Shopify automatic discount; they stay in the
//   cart (repriced) when the cart stops qualifying. Manual removal by the
//   customer is respected for the rest of the session.
(() => {
  let busy = false;
  const stateKey = (i) => 'theme_gift_state_' + i;

  const CartRequest = (path, body) => fetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  const RemoveLine = (key) => CartRequest('/cart/change.js', { id: key, quantity: 0 });

  const GetGiftState = async () => {
    const res = await fetch('/?sections=gift-eligibility').then(r => r.json());
    const html = res['gift-eligibility'];
    if (!html) return null;
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gift-eligibility]');
    return el ? JSON.parse(el.textContent) : null;
  };

  const OfferQualifies = (offer) => {
    if (offer.mode === 'items') {
      return offer.threshold_items > 0 && offer.qualifying_count >= offer.threshold_items;
    }
    const rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
    return offer.threshold_amount > 0 && (offer.qualifying_total / 100) / rate >= offer.threshold_amount;
  };

  // Returns true if any gift was added or removed
  const SyncGifts = async (cart) => {
    const state = await GetGiftState();
    if (!state || !state.offers) return false;

    const enabledOffers = state.offers.filter(o => o.enabled && o.gift_variant);
    let changed = false;

    // Clean up abuse/stray lines. Unmarked gift-variant lines are only
    // stripped in GWP mode - in discount mode the gift is a regular product
    // that customers can legitimately buy. Marked gift lines are always
    // clamped to quantity 1.
    for (const offer of enabledOffers) {
      for (const line of cart.items) {
        if (line.variant_id !== offer.gift_variant) continue;
        const marked = line.properties && line.properties['_Gifted'] === offer.marker;
        if (!marked) {
          if (offer.pricing !== 'discount') {
            await RemoveLine(line.key);
            changed = true;
          }
        } else if (line.quantity > 1) {
          await CartRequest('/cart/change.js', { id: line.key, quantity: 1 });
          changed = true;
        }
      }
    }

    // Gifts superseded by another offer's gift already in the cart
    const superseded = new Set();
    for (const o of enabledOffers) {
      if (!o.supersedes_product) continue;
      if (cart.items.some(i => i.properties && i.properties['_Gifted'] === o.marker)) {
        superseded.add(o.supersedes_product);
      }
    }

    for (const offer of enabledOffers) {
      const giftLine = cart.items.find(i => i.properties && i.properties['_Gifted'] === offer.marker);
      const qualifies = OfferQualifies(offer);
      const isSuperseded = offer.gift_product && superseded.has(offer.gift_product);
      const st = sessionStorage.getItem(stateKey(offer.index));

      // GWP gifts are removed when the cart no longer qualifies (they are
      // hard-priced $0). Discount-mode gifts stay - Shopify simply stops
      // discounting them, and the customer can remove them if they want.
      if (giftLine && (isSuperseded || (!qualifies && offer.pricing !== 'discount'))) {
        await RemoveLine(giftLine.key);
        sessionStorage.removeItem(stateKey(offer.index));
        changed = true;
        continue;
      }

      if (giftLine) {
        sessionStorage.setItem(stateKey(offer.index), 'added');
        continue;
      }

      // Gift absent. If we previously added it and it vanished while still
      // qualifying, the customer removed it - respect that for this session.
      if (st === 'added' && qualifies && !isSuperseded) {
        sessionStorage.setItem(stateKey(offer.index), 'dismissed');
        continue;
      }
      if (st === 'dismissed') continue;

      if (qualifies && !isSuperseded) {
        await CartRequest('/cart/add.js', {
          items: [{ id: offer.gift_variant, quantity: 1, properties: { '_Gifted': offer.marker } }]
        });
        const after = await UTILS.GetCartJson();
        const added = after.items.find(i => i.properties && i.properties['_Gifted'] === offer.marker);
        if (!added) continue;
        if (added.final_line_price > 0) {
          // Not free (misconfigured gift product or missing discount) - undo
          await RemoveLine(added.key);
          sessionStorage.setItem(stateKey(offer.index), 'dismissed');
          continue;
        }
        sessionStorage.setItem(stateKey(offer.index), 'added');
        changed = true;

        // Remove a superseded gift (e.g. the kit already includes drops).
        // Clear its state so it can return if this gift is later removed.
        if (offer.supersedes_product) {
          const victim = after.items.find(i =>
            i.product_id === offer.supersedes_product &&
            i.properties && i.properties['_Gifted'] &&
            i.properties['_Gifted'] !== offer.marker
          );
          if (victim) {
            await RemoveLine(victim.key);
            const victimOffer = enabledOffers.find(o => o.gift_product === offer.supersedes_product);
            if (victimOffer) sessionStorage.removeItem(stateKey(victimOffer.index));
          }
        }
      }
    }

    return changed;
  };

  const RunCartAutomation = async () => {
    if (busy) return;
    busy = true;
    try {
      const cart = await UTILS.GetCartJson();

      if (!cart.items.length) {
        [1, 2, 3].forEach(n => sessionStorage.removeItem(stateKey(n)));
        return;
      }

      const giftsChanged = await SyncGifts(cart);

      if (giftsChanged) UTILS.RefreshCart();
    } catch (e) {
      console.error('cart automation failed', e);
    } finally {
      busy = false;
    }
  };

  let queueTimer;
  const QueueRun = () => {
    clearTimeout(queueTimer);
    queueTimer = setTimeout(RunCartAutomation, 250);
  };

  document.addEventListener('cart:updated', QueueRun);
  document.addEventListener('cart:item-added', QueueRun);

  // Trigger from the network layer: watch every cart mutation from any script
  const CART_MUTATION = /\/cart\/(add|change|update|clear)/;
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const url = String(args[0] && (args[0].url || args[0]));
    const p = origFetch.apply(this, args);
    if (CART_MUTATION.test(url)) p.then(QueueRun).catch(() => {});
    return p;
  };
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_MUTATION.test(String(url))) {
      this.addEventListener('loadend', QueueRun);
    }
    return origOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', QueueRun);
  } else {
    QueueRun();
  }
})();

/* ============================================================
   Display currency (theme-native, replaces Beast Currency Converter)
   DISPLAY ONLY — checkout is always USD.
   Rates: window.Currency from Shopify's daily currencies.js (loaded via
   snippets/display-currency.liquid) → localStorage copy of last live rates
   → inline snapshot → plain USD. Country/currency comes from the config JSON
   (localization.country, IP-assigned by Shopify Markets). Manual dropdown
   choice (localStorage) beats geo. Rates never re-write prices mid-view:
   a span converted this render keeps its value until the next DOM change.
   ============================================================ */
(function () {
  var cfgEl = document.getElementById('ec-dc-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (err) { return; }

  var supported = String(cfg.supported || '').split(',')
    .map(function (c) { return c.trim().toUpperCase(); })
    .filter(function (c) { return c && c !== 'USD'; });
  if (!supported.length) return;

  var LS_CUR = 'ec_display_currency';
  var LS_RATES = 'ec_fx_rates';
  var MONEY_RE = /\$\s?(\d[\d,]*(?:\.\d{1,2})?)/;

  function lsGet(k) { try { return localStorage.getItem(k); } catch (err) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (err) {} }

  function cacheLiveRates() {
    if (window.Currency && Currency.rates && Currency.rates.USD) {
      lsSet(LS_RATES, JSON.stringify({ ts: Date.now(), rates: Currency.rates }));
      return true;
    }
    return false;
  }

  function getRates() {
    if (window.Currency && Currency.rates && Currency.rates.USD) return Currency.rates;
    try {
      var cached = JSON.parse(lsGet(LS_RATES) || 'null');
      if (cached && cached.rates && cached.rates.USD) return cached.rates;
    } catch (err) {}
    return (cfg.snapshot && cfg.snapshot.rates) || null;
  }

  // Country → currency for the currencies in the snapshot/rate table. Static because
  // with USD-only presentment, Liquid reports every country's currency as USD.
  var COUNTRY_CUR = {
    CA:'CAD', AU:'AUD', GB:'GBP', JP:'JPY', KR:'KRW', SG:'SGD', HK:'HKD', AE:'AED',
    SA:'SAR', NZ:'NZD', CH:'CHF', LI:'CHF', MX:'MXN', TH:'THB', TW:'TWD', MY:'MYR',
    PH:'PHP', IN:'INR', ID:'IDR', DK:'DKK', SE:'SEK', NO:'NOK', PL:'PLN', CZ:'CZK',
    IL:'ILS', TR:'TRY', ZA:'ZAR', BR:'BRL', CN:'CNY', VN:'VND', QA:'QAR', KW:'KWD', BH:'BHD',
    AT:'EUR', BE:'EUR', CY:'EUR', DE:'EUR', EE:'EUR', ES:'EUR', FI:'EUR', FR:'EUR',
    GR:'EUR', HR:'EUR', IE:'EUR', IT:'EUR', LT:'EUR', LU:'EUR', LV:'EUR', MT:'EUR',
    NL:'EUR', PT:'EUR', SI:'EUR', SK:'EUR', MC:'EUR', AD:'EUR', SM:'EUR', ME:'EUR'
  };

  var GEO_KEY = 'ec_dc_geo'; // Shopify-detected country, cached 30 days
  function cachedGeoCountry() {
    try {
      var g = JSON.parse(lsGet(GEO_KEY) || 'null');
      if (g && g.c && Date.now() - g.ts < 2592000000) return g.c;
    } catch (err) {}
    return null;
  }

  function targetCurrency() {
    var manual = lsGet(LS_CUR);
    if (manual === 'USD') return 'USD';
    if (manual && supported.indexOf(manual) !== -1) return manual;
    // 1) Shopify's server-side market context (localization.country) — zero calls.
    //    Covers native selector choices, market URLs, and any Shopify-side assignment.
    //    (countryCurrency can't be used directly: with USD-only presentment it is
    //    always USD, so we map the country code instead.)
    var ctxCur = String(cfg.countryCurrency || '').toUpperCase();
    if (supported.indexOf(ctxCur) !== -1) return ctxCur;
    var ctxC = String(cfg.country || '').toUpperCase();
    var ctxMapped = ctxC ? COUNTRY_CUR[ctxC] : null;
    if (ctxMapped && supported.indexOf(ctxMapped) !== -1) return ctxMapped;
    // 2) Shopify geo detection (browsing_context_suggestions), cached per visitor
    var geoC = cachedGeoCountry();
    var geoCur = geoC ? COUNTRY_CUR[geoC] : null;
    return geoCur && supported.indexOf(geoCur) !== -1 ? geoCur : 'USD';
  }

  // one-time per visitor: ask Shopify (same-origin, its own Markets geo infra) which
  // country this IP is in; cache 30 days, then re-run conversion if it changes things
  function detectCountry() {
    fetch('/browsing_context_suggestions?source=country_selector&country%5Benabled%5D=true', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (!c) return;
        lsSet(GEO_KEY, JSON.stringify({ c: c, ts: Date.now() }));
        if (!lsGet(LS_CUR)) pass();
      })
      .catch(function () {});
  }

  var fmtCache = {};
  function fmt(amount, cur, whole) {
    var key = whole ? cur + '#w' : cur;
    var f = fmtCache[key];
    if (!f) {
      try {
        // CAD shows a bare "$" like USD (Chloe, Jul 12: "CA$" crowds price rows
        // onto a second line; the cart FX note + currency selector disambiguate).
        // Other currencies keep prefixed symbols (A$, NZ$...) — a bare "$" for
        // those caused a "wrong conversion" report (Chloe, Jul 11).
        var opts = { style: 'currency', currency: cur, currencyDisplay: (cur === 'USD' || cur === 'CAD') ? 'narrowSymbol' : 'symbol' };
        if (whole) { opts.minimumFractionDigits = 0; opts.maximumFractionDigits = 0; }
        f = new Intl.NumberFormat('en', opts);
      } catch (err) {
        f = { format: function (n) { return cur + ' ' + (whole ? Math.round(n) : n.toFixed(2)); } };
      }
      fmtCache[key] = f;
    }
    return f.format(amount);
  }

  // Wrap raw $-amounts in text nodes with span.money (Beast-compatible tagging).
  function tagTextNodes() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('$') === -1) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p || p.closest('script,style,noscript,textarea,select,[data-ec-dc-skip],.money')) return NodeFilter.FILTER_REJECT;
        return MONEY_RE.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var frag = document.createDocumentFragment();
      var text = node.nodeValue;
      var m;
      while ((m = MONEY_RE.exec(text))) {
        if (m.index > 0) frag.appendChild(document.createTextNode(text.slice(0, m.index)));
        var span = document.createElement('span');
        span.className = 'money';
        span.textContent = m[0];
        frag.appendChild(span);
        text = text.slice(m.index + m[0].length);
      }
      if (text) frag.appendChild(document.createTextNode(text));
      node.parentNode.replaceChild(frag, node);
    });
  }

  function convertSpans(cur, rates) {
    var spans = document.querySelectorAll('span.money');
    for (var i = 0; i !== spans.length; i++) {
      var el = spans[i];
      var usd = el.getAttribute('data-ec-usd');
      if (usd === null) {
        var m = MONEY_RE.exec(el.textContent);
        if (!m) continue;
        usd = m[1].replace(/,/g, '');
        el.setAttribute('data-ec-usd', usd);
      }
      if (el.getAttribute('data-ec-cur') === cur) continue;
      var val = parseFloat(usd);
      if (!isFinite(val)) continue;
      if (cur === 'USD') {
        el.textContent = fmt(val, 'USD');
      } else {
        var rate = rates && rates[cur];
        if (!rate) continue; // no rate available → leave USD untouched
        var conv = val / rate;
        // Whole-number rounding is scoped to the promo tag pills on product
        // grids (.product-badges from snippets/new-product-badges.liquid /
        // product-badges.liquid — "$28 OFF 3+"-style labels, whose $ text
        // nodes tagTextNodes wraps as span.money). Everywhere else converted
        // prices keep normal decimals.
        // value rounds to whole dollars everywhere (>= 10); only badge pills
        // drop the ".00" in display
        var rounded = cfg.rounding === 'whole' && conv >= 10;
        if (rounded) conv = Math.round(conv);
        // Whole-dollar DISPLAY (drop the ".00"): badge pills + any line that
        // mentions free shipping ("Free ship on $75", the cart shipping bar,
        // gift markers) - "Free shipping on $75.00" reads wrong (Chloe, Jul 12).
        // Allow one word between "free" and "ship" ("Free standard shipping"),
        // and walk up to 3 short ancestors: the PDP callouts strip nests each
        // price in a bare span, so the words sit levels above (Chloe, Jul 12).
        var wholeDisplay = rounded && !!el.closest('.product-badges,.recommended-products__heading,.ec-ot__title');
        if (rounded && !wholeDisplay) {
          var anc = el.parentElement;
          for (var d = 0; anc && d < 3; d++, anc = anc.parentElement) {
            var atext = anc.textContent || '';
            if (atext.length > 200) break; // container too broad - stop walking
            if (/free\s+(?:\w+\s+)?ship/i.test(atext)) { wholeDisplay = true; break; }
          }
        }
        el.textContent = fmt(conv, cur, wholeDisplay);
      }
      el.setAttribute('data-ec-cur', cur);
    }
  }

  function syncSelectors(cur) {
    var wraps = document.querySelectorAll('[data-ec-dc-selector]');
    for (var i = 0; i !== wraps.length; i++) {
      wraps[i].hidden = false;
      var sel = wraps[i].querySelector('select');
      if (sel && sel.value !== cur) sel.value = cur;
    }
  }

  var passQueued = false;
  function pass() {
    passQueued = false;
    var cur = targetCurrency();
    document.documentElement.setAttribute('data-ec-dc', cur);
    syncSelectors(cur);
    if (cur === 'USD' && !document.querySelector('span.money[data-ec-cur]')) return; // nothing converted, nothing to do
    tagTextNodes();
    convertSpans(cur, getRates());
  }
  function queuePass() {
    if (passQueued) return;
    passQueued = true;
    setTimeout(passSilently, 150);
  }
  function passSilently() {
    // our own span writes would re-trigger the observer and schedule a second
    // full pass; disconnect around the write and flush pending records
    if (!observer) { pass(); return; }
    observer.disconnect();
    try { pass(); } finally {
      observer.takeRecords();
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest && e.target.closest('[data-ec-dc-selector] select');
    if (!sel) return;
    lsSet(LS_CUR, sel.value);
    // marks stay: convertSpans reconverts any span whose data-ec-cur differs from the new target
    pass();
  });

  function start() {
    // geo fetch: only when nothing else answers — no manual choice, no usable server
    // context (currency or mapped country), and no cached detection
    var ctxCur = String(cfg.countryCurrency || '').toUpperCase();
    var ctxMapped = COUNTRY_CUR[String(cfg.country || '').toUpperCase()];
    var ctxUsable = supported.indexOf(ctxCur) !== -1 || (ctxMapped && supported.indexOf(ctxMapped) !== -1);
    if (!lsGet(LS_CUR) && !ctxUsable && !cachedGeoCountry()) detectCountry();
    // poll briefly for live rates (currencies.js is defer-loaded just before this file)
    var tries = 0;
    (function waitRates() {
      if (cacheLiveRates() || tries++ > 20) { pass(); observe(); return; }
      setTimeout(waitRates, 100);
    })();
  }

  var observer = null;
  function observe() {
    if (observer || !window.MutationObserver) return;
    observer = new MutationObserver(function () {
      if (targetCurrency() === 'USD') return;
      queuePass();
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

// v: jul10-rounding-scope
